import u from "./getOutletAvailableOrderFormats.mjs";
import "./constants.mjs";
import "@ancon/wildcat-types";
function d(o, f) {
  const i = u(
    o
  );
  return f.reduce((e, t) => (t.acceptingPreOrders && i.forEach((r) => {
    (t.orderFormat & r) === r && (e.includes(r) || e.push(r));
  }), e), []);
}
export {
  d as default
};
